import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const DEFAULT_CONTENT = {
  hero_title: "The Epic Center Birmingham",
  hero_subtitle: "Where Community, Celebration & Culture Meet.",
  about_heading: "West Birmingham's Newest Entertainment Destination",
  about_body1:
    "The Epic Center is a modern multi-use event venue designed for unforgettable experiences. Located in the heart of Birmingham, it serves as a premier destination for celebrations, concerts, private events, workshops, and community gatherings.",
  about_body2:
    'Built with vision and purpose by Edward and Valencia "Mrs. V" Johnson, The Epic Center was created to bring people together through entertainment, empowerment, and elevated event experiences.',
  about_image:
    "https://customer-assets.emergentagent.com/job_bham-events-hub/artifacts/9xeu0eb0_IMG_2717.jpeg",
  contact_address1: "1301 3rd Avenue West",
  contact_address2: "Birmingham, AL 35208",
  contact_phone1: "(205) 212-0399",
  contact_phone2: "(205) 746-6466",
  contact_email: "hello@epiccenterbham.com",
};

const ContentContext = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    api
      .get("/content")
      .then((res) => setContent({ ...DEFAULT_CONTENT, ...res.data }))
      .catch(() => {});
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
